/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Sidebar_ResizeInputs */



/**
* | output |
* | --- |
* | "Resize sidebar" |
*
* @param {Settings_Sidebar_ResizeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const settings_sidebar_resize = /** @type {((inputs?: Settings_Sidebar_ResizeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Sidebar_ResizeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Seitenleistenbreite ändern")
	return /** @type {LocalizedString} */ ("Resize sidebar")
});